import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import "./style.css";
import { UserAuth } from "../Context";
import formatPrice from "../lib/formatPrice";
import AddToFavorites from "../UserProfile/ProfileShoppingList/AddToFavorites";
import ProductCardBottom from "./ProductCardBottom";
const PrevArrow = ({ style, onClick }) => {
  return (
    <div
      className="slick-prev "
      style={{
        ...style,
        fontSize: "24px",
        zIndex: 1,
        left: "2%",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#D7D7D7",
        borderRadius: "0.2rem",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <span
        className="carousel-control-prev-icon"
        style={{ filter: "brightness(0.1)", width: "10px", height: "10px" }}
      ></span>
    </div>
  );
};

const NextArrow = ({ style, onClick }) => {
  return (
    <div
      style={{
        ...style,
        backgroundColor: "#D7D7D7",
        fontSize: "24px",
        zIndex: 1,
        right: "2%",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // background: "rgba(var(--bs-primary-rgb), 0)",
        borderRadius: "0.2rem",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <span
        className="carousel-control-next-icon"
        style={{ filter: "brightness(0.1)", width: "10px", height: "10px" }}
      ></span>
    </div>
  );
};
const ProductCard8 = ({ product, index }) => {
  const [loading, setLoading] = useState(true);
  const [showCard, setShowCard] = useState(true);
  const [badgeText, setBadgeText] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  // const activeBrands = useActiveBrandsStore((state) => state.activeBrands);
  const { user } = UserAuth();
  let url = process.env.REACT_APP_API + `/api/activity/${user?.uid}`;

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleImageLoad = () => {
    setLoading(false);
  };

  // if (!showCard) return;
  const settings = {
    speed: 500,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    swipe: true,
    nextArrow:
      !loading && product?.secondaryImages?.length > 0 ? <NextArrow /> : null, // Show only when not loading
    prevArrow:
      !loading && product?.secondaryImages?.length > 0 ? <PrevArrow /> : null,
  };
  useEffect(() => {
    // Determine which badge to show (if any)
    const now = new Date();
    const lastUpdate = product.dateLastUpdate
      ? new Date(product.dateLastUpdate)
      : null;
    const isRecent = lastUpdate && now - lastUpdate <= 7 * 24 * 60 * 60 * 1000;
    if (isRecent) {
      if (product.oldPrice > 0) {
        setBadgeText("Price Drop");
      } else {
        setBadgeText("New Arrival");
      }
    } else {
      setBadgeText(null);
    }
  }, []);
  if (!showCard) return;
  // if (product?.name === "Cambric Shalwar") console.log("product", product);
  return (
    <div
      className="d-flex flex-column justify-content-between"
      style={{ padding: isSmallScreen ? "6px 1.5px" : "8px 6px" }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          // height: "280px",
          height: index === 0 ? "250px" : index === 3 ? "200px" : "",
        }}
      >
        {showCard ? (
          <>
            <Link to={`/ProductDetails/${product?.id}`}>
              <Card.Img
                src={product?.imageUrl}
                style={{
                  opacity: 1, // Hide the image until it's fully loaded
                  transition: "opacity 0.5s ease-in-out",
                  objectFit: "cover",
                  objectPosition: "top",
                  height: "100%",
                  display: "inline",
                  borderRadius: "6px 6px 0px 0px",
                  // objectPosition: "top",
                  filter: "contrast(1.1) brightness(0.95)",
                }}
                onError={() => setShowCard(false)}
                loading="lazy"
              />
            </Link>
          </>
        ) : (
          <Link to={`/ProductDetails/${product?.id}`}>
            <Card.Img
              className="rounded-2 skeleton"
              style={{
                transition: "opacity 0.5s ease-in-out",
                objectFit: "cover",
                height: isSmallScreen ? "80%" : "100%",
                display: "inline",
                objectPosition: "top",
              }}
              loading="lazy"
            />
          </Link>
        )}
        <div
          className="d-flex align-items-center"
          style={{
            position: "absolute",
            bottom: "3px",
            right: "3px",
            gap: "3px",
          }}
        >
          <AddToFavorites
            userId={user?.uid}
            productId={product?.id}
            product={product}
            type={"product"}
          />
        </div>
        <div
          className="d-flex align-items-center"
          style={{
            position: "absolute",
            top: "3px",
            right: "3px",
            gap: "3px",
          }}
        >
          {product?.discount > 0 && (
            <div
              style={{
                backgroundColor: "#FFE1DC",
                height: "20px",
                borderRadius: "2px 4px 2px 2px",
                width: "47px",
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  textAlign: "center",
                  fontSize: "11px",
                  letterSpacing: "0%",
                  color: "#FF4424",
                }}
              >
                -{product?.discount ?? "0"}%
              </div>
            </div>
          )}
        </div>
      </div>

      <ProductCardBottom isSmallScreen={isSmallScreen} product={product} />
    </div>
  );
};
export default ProductCard8;
